import type { AnalyticsPayload } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { fireErrorAnalyticsCommon } from '@atlassian/jira-issue-commmon-error-boundary/src/utils/fire-error-analytics/index.tsx';

export const fireIssueTransitionErrorAnalytics = (payload: AnalyticsPayload): void => {
	const { attributes = {}, error, ...otherPayload } = payload;

	fireErrorAnalyticsCommon({
		...otherPayload,
		attributes: {
			...attributes,
		},
		error,
	});
};
